export const RQ_GET_SPECIALITY_COVERAGE_REPORTS_API = {
  url: 'reports/brand/speciality_coverage_report/<%= divisionId %>/<%= specialityId %>/<%= fromDate %>/<%= toDate %>',
  method: 'GET',
  auth: true,
};

export const RQ_GET_DIVISION_WISE_SPECIALITY_COVERAGE_REPORTS_API = {
  url: 'reports/brand/division_speciality_coverage_report/<%= divisionId %>/<%= specialityId %>/<%= fromDate %>/<%= toDate %>',
  method: 'GET',
  auth: true,
};
